const baseURL = (process.env.NODE_ENV === "development" ? "http://localhost" : "https://app.intelimotor.com") + "/api";

export const postShopsLead = (data) =>
  fetch(`${baseURL}/shops/leads`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  }).then((res) => res.json());

export default { postShopsLead };
